export default [
  {
    name: "IsValid",
    title: 'Status',
    width: "350px",
    sortField: "IsValid",
    formatter(value) {
      if (value == "true") {
        return '<i class="fa-solid fa-circle-check green-font"></i>';
      } else {
        return '<i class="fas fa-exclamation-triangle red-font"></i>';
      }
    }
  },
  {
    name: "Email",
    title: 'Email',
    width: "350px",
    sortField: "Email",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "OrganisationName",
    title: 'Organisation Name',
    width: "350px",
    sortField: "OrganisationName",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "Phone",
    title: 'Phone No',
    width: "350px",
    sortField: "Phone",
    formatter(value) {
      if (value) {
        return value;
      } else {
        return '--';
      }
    }
  },
  {
    name: "ErrorMsg",
    title: 'Error Message',
    width: "350px",
    sortField: "ErrorMsg"
  }


]